import { Component } from '@angular/core';
import { soundpostReportOutputAgreementBalanceEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Report Output Agreement Balances') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostreportoutputagreementbalance-form',
    templateUrl: './soundpostreportoutputagreementbalance.form.component.html'
})
export class soundpostReportOutputAgreementBalanceFormComponent extends BaseFormComponent {
    public record!: soundpostReportOutputAgreementBalanceEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

